import React from 'react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import { Avatar } from '../lib/ui';
import { useFetch } from '../lib/useFetch';

// มือเป็น = ยังไม่เปีย (ยังรอรับเงิน/สินค้า) · มือตาย = เปียไปแล้ว (รับแล้ว)
export default function HandsBoard({ circleId, onSelect }) {
  const { data, error } = useFetch(`/circles/${circleId}/standings`, [circleId]);
  if (error && [401, 403].includes(error?.response?.status)) {
    return (
      <div data-testid="hands-board-locked" style={{ background: PS.surface, border: `1px dashed ${PS.line}`, borderRadius: 18, padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 10, color: PS.textMuted }}>
        <Icon.lock size={16} stroke={PS.textMuted} />
        <span style={{ fontSize: 12.5, lineHeight: 1.5 }}>เข้าร่วมวงเพื่อดูสถานะมือ (มือเป็น/มือตาย) และเครดิตของสมาชิก</span>
      </div>
    );
  }
  if (!data) return null;
  const { alive_count = 0, dead_count = 0, members = [] } = data;

  return (
    <div data-testid="hands-board" style={{ background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18, overflow: 'hidden' }}>
      <div style={{ display: 'flex', gap: 1, background: PS.line }}>
        <div style={{ flex: 1, background: 'oklch(0.78 0.06 155 / 0.16)', padding: '12px 14px' }}>
          <div style={{ fontSize: 10.5, color: 'oklch(0.34 0.08 155)', textTransform: 'uppercase', letterSpacing: 0.6 }}>มือเป็น · ยังไม่เปีย</div>
          <div className="num" data-testid="hands-alive-count" style={{ fontSize: 22, fontWeight: 600, color: 'oklch(0.4 0.09 155)', marginTop: 2 }}>{alive_count}</div>
        </div>
        <div style={{ flex: 1, background: PS.surface2, padding: '12px 14px' }}>
          <div style={{ fontSize: 10.5, color: PS.textMuted, textTransform: 'uppercase', letterSpacing: 0.6 }}>มือตาย · เปียแล้ว</div>
          <div className="num" data-testid="hands-dead-count" style={{ fontSize: 22, fontWeight: 600, color: PS.text, marginTop: 2 }}>{dead_count}</div>
        </div>
      </div>
      <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {members.map((m, i) => {
          const alive = m.hand === 'alive';
          return (
            <div key={i} data-testid={`hand-row-${m.slot_number}`} onClick={() => onSelect?.(m)} className={onSelect ? 'ps-press' : ''} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: onSelect ? 'pointer' : 'default' }}>
              <Avatar name={m.name} size={30} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {m.name}{m.role === 'host' && <span style={{ fontSize: 10.5, color: PS.terracotta, marginLeft: 6, fontWeight: 600 }}>ท้าว</span>}
                </div>
                <div style={{ fontSize: 10.5, color: PS.textMuted }}>มือ #{String(m.slot_number).padStart(2, '0')} · เครดิต {m.credit_score}</div>
              </div>
              {alive ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', borderRadius: 999, background: 'oklch(0.78 0.06 155 / 0.3)', color: 'oklch(0.34 0.08 155)', fontSize: 11, fontWeight: 600 }}>
                  <Icon.check size={11} stroke="oklch(0.34 0.08 155)" sw={2.4} />มือเป็น
                </div>
              ) : (
                <div style={{ padding: '4px 10px', borderRadius: 999, background: PS.panel, color: PS.textMuted, fontSize: 11, fontWeight: 600 }}>มือตาย{m.won_round ? ` · รอบ ${m.won_round}` : ''}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
